import { useQuery } from '@tanstack/react-query';
import type { Alarm } from '@bridgewerk/shared';
import { getApiClient } from '../../../lib/api-client.js';
import { machineKeys } from '../../../lib/query-keys.js';

export interface MachineAlarmsQuery {
  readonly alarms: Alarm[] | undefined;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly refetch: () => void;
}

export function useMachineAlarms(
  shopId: string | null,
  machineId: string | null,
): MachineAlarmsQuery {
  const enabled = !!shopId && !!machineId;
  const query = useQuery({
    queryKey: enabled ? machineKeys.alarms(shopId!, machineId!) : ['machines', 'none', 'alarms'],
    queryFn: () => getApiClient().getMachineAlarms(shopId!, machineId!),
    enabled,
  });
  return {
    alarms: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
